export default "__VITE_ASSET__dd67d9c2__"